import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
declare var app;
@Component({
  selector: 'app-a2-list-vistplan-list',
  templateUrl: './a2-list-vistplan-list.component.html',
  styleUrls: ['./a2-list-vistplan-list.component.scss']
})
export class A2ListVistplanListComponent extends GridBaseCase {
  month: any = new Date();
  searchDate = null;
  dataArrayList: Array<any> = [];
  addobject: any = {};
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  state:any;//状态
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) { 
    super(); 
    const d = this.activaRouter.snapshot.paramMap.get('id').split("&")[1];
    if(d){
      this.month = new Date((d+"-01").replace(/-/g,"/"));
    }
  }

  // ngOnInit() {
  // }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }

  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    that.state = that.activaRouter.snapshot.paramMap.get('type');
    const ID = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    const date = that.activaRouter.snapshot.paramMap.get('id').split("&")[1];
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 100;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
      // console.log(that.month);
      let obj = {};
      if (!that.searchDate) {
        let nowyear: any = date.split('-')[0];
        let nowmonth: any = date.split('-')[1];
        // obj["startDate"] = nowyear + "-" + nowmonth;
        let startDate = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
        let day = new Date(nowyear, nowmonth, 0);
        let endDate = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
        //obj["startDate"] = that.com.BetweenDate(startDate, endDate);
        that.searchDate = that.com.BetweenDate(startDate, endDate);
      }
      //排班
      obj["a_FK_SystemUser_ID"] = ID;
      // obj["a_Code"] = "s002";//that.state;
      if (that.searchDate) {
        obj["a_VisitDate"] = that.searchDate;
        localStorage.setItem("spdate",that.month);
        // body.RequestBody = JSON.stringify({ "a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_ModifyTime": that.searchDate });
      }
      obj["a_VisitState"]=that.state;
      body.RequestBody = JSON.stringify(obj);
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              if(element.bindingField == "startdate" || element.bindingField == "enddate"){
                objfield[element.bindingField] = { "value": item[element.field].replace(/-/g,"/"), "text": element.text };
              }else{
                objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          that.infiniteScroll.disabled = true;
        }else{
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  changeMonth(type, $event:any="") {
    const that=this;
    let t = type;
    let current = new Date(this.month);
    let current_year = null;
    let current_month = null;
    if (t == 'pre') {
      current_year = current.getFullYear();
      current_month = this.getmonth(current.getMonth());
    } else if (t == 'next') {
      if((current.getMonth()+2)>12){
        current_year = current.getFullYear()+1;
        current_month = "01";
      }else{
        current_year = current.getFullYear();
        current_month = that.getmonth(current.getMonth() + 2);
      }
    } else if (t == 'datetime') {
      console.log($event.detail.value);
      current_year = $event.detail.value.split("-")[0];
      current_month = $event.detail.value.split("-")[1];
    }

    if (current_month == 13) {
      current_year += 1;
      current_month = 1;
    } else if (current_month == 0) {
      current_year -= 1;
      current_month = 12;
    }
    //获取月份对应的天数
    let d = new Date(current_year, current_month, 0);
    // console.log(d.getDate());

    let startmonthDay = current_year + "-" + current_month + "-" + "01 00:00:00";
    let endmonthDay = current_year + "-" + current_month + "-" + d.getDate() + " 23:59:59";
    // this.searchDate = current_year + "-" + current_month;
    this.searchDate = this.com.BetweenDate(startmonthDay, endmonthDay);
    this.month = current_year + '-' + current_month;
    if (t == 'datetime') {
      this.LoadData(1);
    }
  }

  EventLink(ev: any, item: any) {
    if (item.isCheck) {
      item.isCheck = false;
    } else {
      item.isCheck = true;
    }
  }
  /**
   * 审批
   * @param event 通过:true,驳回:false
   */
  EventClick(event: Boolean) {
    // console.log(event);
    const that = this;
    that.msg.Show("暂未开通");
    return;
    let objArray: Array<any> = [];
    let webcontext: WebParameterContext = new WebParameterContext();
    webcontext.Account = that.com.GetAccount;
    webcontext.ConfigName = "TBScheduleNormalXML";
    webcontext.ConfigType = "form";
    webcontext.OpType = "edite";
    webcontext.ID = that.com.GetAccount.Id;
    webcontext.SpecialParameter = "LeaveApproval"
    if (that.dataArrayList.length > 0 && that.dataArrayList.findIndex(itme => itme.isCheck) >= 0) {
      that.addobject = [];
      that.dataArrayList.forEach((items, index) => { // obj["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
        that.addobject = {};
        if (items.isCheck) {
          that.addobject["a_ID"] = items.ID.value;//主表ID
          if (event) {
            that.addobject["a_SNState"] = 1;
          } else {
            that.addobject["a_SNState"] = 2;
          }
          objArray.push(that.addobject);
        }
      });
      if(objArray.length<=0){
        that.msg.Alert("请选择需要审批的数据");
        return;
      }
      console.log(that.dataArrayList[0]);
      // console.log(JSON.stringify(objArray));
      webcontext.RequestBody = JSON.stringify(objArray);
      // console.log(JSON.stringify(webcontext));
      that.http.post(app.DEFAULTURL, webcontext).then(data => {
        if (data.ResponseMessage.Success) {
          that.LoadData(1);
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      });
    } else {
      that.msg.Alert("必须选择一项");
    }
  }
  ///批量撤销
  EventApproveClick(){
    const that = this;
    that.msg.Show("暂未开通");
    return;
    let objArray: Array<any> = [];
    let webcontext: WebParameterContext = new WebParameterContext();
    webcontext.Account = that.com.GetAccount;
    webcontext.ConfigName = "TBScheduleNormalXML";
    webcontext.ConfigType = "form";
    webcontext.OpType = "edite";
    webcontext.ID = that.com.GetAccount.Id;
    // webcontext.SpecialParameter = "LeaveApproval"
    if (that.dataArrayList.length > 0 && that.dataArrayList.findIndex(itme => itme.isCheck) >= 0) {
      that.addobject = [];
      that.dataArrayList.forEach((items, index) => { // obj["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
        that.addobject = {};
        if (items.isCheck) {
          that.addobject["a_ID"] = items.ID.value;//主表ID
          that.addobject["a_SNState"] = 3;//表示撤销
          objArray.push(that.addobject);
        }
      });
      if(objArray.length<=0){
        that.msg.Alert("请选择需要撤销的数据");
        return;
      }
      //console.log(that.dataArrayList[0]);
      // console.log(JSON.stringify(objArray));
      webcontext.RequestBody = JSON.stringify(objArray);
      // console.log(JSON.stringify(webcontext));
      that.http.post(app.DEFAULTURL, webcontext).then(data => {
        if (data.ResponseMessage.Success) {
          that.LoadData(1);
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      });
    } else {
      that.msg.Alert("必须选择一项");
    }
  }
  getmonth(month: Number) {
    let months: any = month;
    if (month < 10) {
      months = "0" + month
    }
    return months;
  }

}
